import { TransactionResultModel, TransactionResultReqParamsModel } from "src/app/card-operations-core/models/transaction-result-models";
import { AppConfig } from "src/app/config-service/app.config";

export class PaymentViewModel{
    private dateTime!: Date;
    private amount!: string;
    private message!: string;
    private ref_code!: string;
    private mdErrorMsg?: string;
    private currency!: string;

    constructor(private cityCurrency:string){
        this.currency = cityCurrency;
    }

    public setInitials = (mdErrorMsg:string) : void => {
        if(mdErrorMsg){
            this.message = mdErrorMsg;
        }
    }

    public setTransactionRequestValues(transactionReqParams: TransactionResultReqParamsModel, amount: string){
        this.ref_code = transactionReqParams.refCode
        this.amount = amount;
    }

    public setTransactionCompleteValues(transactionResult: TransactionResultModel){
        const result = transactionResult.result;
        this.dateTime = new Date(
            result.dateTime.replace(
                /^(\d{4})(\d\d)(\d\d)(\d\d)(\d\d)(\d\d)$/,
                '$4:$5:$6 $2/$3/$1'
            )
        );

        if (result.code == 0) {
            this.message = result.message;
        } else {
            this.message = this.message + " [" + result.message + "]";
        }

    }

    public getDateTime = () => {
        return this.dateTime;
    }

    public getAmount = () => {
        return this.amount;
    }

    public getMessage = () => {
        return this.message;
    }

    public getRefCode = () => {
        return this.ref_code;
    }

    public getCurrency = () => {
        return this.currency;
    }
}